import { useOutletContext } from 'react-router-dom'
import Sidebar from '../../containers/Sidebar'
import HomePage from '../HomePage'

// This page is only required so that the home page loader doesn't show whilst we wait to check if there are any connected accounts
export default function DashboardPage({ children }: any) {
    const { connectedAccounts } = useOutletContext<{ connectedAccounts: Map<number, number> }>()

    return !!connectedAccounts ? (
        <Sidebar>
            <HomePage />
        </Sidebar>
    ) : null
}
